import { mergeStyles } from "@fluentui/react/lib/Styling";
import { designTokens } from "./shared.styles";
export const incidentTilesStyles = {
    scrollContainer: mergeStyles({
        position: "relative",
        display: "flex",
        alignItems: "center",
        overflowX: "auto",
        overflowY: "hidden",
        width: "100%",
    }),
    toolbar: mergeStyles({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: designTokens.spacing.md,
        marginBottom: designTokens.spacing.sm,
        flexWrap: "wrap",
    }),
    searchBox: mergeStyles({
        minWidth: "280px",
        flex: 1,
        maxWidth: "420px",
    }),
    paginationContainer: mergeStyles({
        display: "flex",
        alignItems: "center",
        gap: designTokens.spacing.sm,
    }),
    pageInfo: mergeStyles({
        fontSize: designTokens.fontSize.sm,
        fontWeight: 600,
        color: designTokens.colors.text,
        minWidth: "92px",
        textAlign: "center",
    }),
    inlineMessage: mergeStyles({
        marginBottom: designTokens.spacing.sm,
    }),
    container: mergeStyles({
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "stretch",
        overflowX: "visible",
        overflowY: "hidden",
        padding: `${designTokens.spacing.lg} 0`,
        gap: designTokens.spacing.md,
        width: "max-content",
        minWidth: "100%",
    }),
    tile: mergeStyles({
        flex: "0 0 280px",
        width: "280px",
        minWidth: "280px",
        maxWidth: "280px",
        padding: designTokens.spacing.md,
        margin: "0",
        border: `2px solid ${designTokens.colors.borderLight}`,
        borderRadius: designTokens.borderRadius,
        backgroundColor: designTokens.colors.white,
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        position: "relative",
        cursor: "pointer",
        transition: "border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease",
        ":hover": {
            borderColor: designTokens.colors.primary,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
        },
    }),
    tileSelected: mergeStyles({
        borderColor: "#005a9e",
        backgroundColor: "#e5f1fb",
        boxShadow: "0 0 0 2px #005a9e inset, 0 8px 16px rgba(0, 90, 158, 0.18)",
    }),
    tileOutage: mergeStyles({
        background: "linear-gradient(180deg, #fff5f5 0%, #ffffff 24%)",
    }),
    selectedIndicator: mergeStyles({
        position: "absolute",
        top: "10px",
        right: "10px",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: "#005a9e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
    }),
    loadingMoreTile: mergeStyles({
        flex: "0 0 180px",
        width: "180px",
        minWidth: "180px",
        maxWidth: "180px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: designTokens.spacing.md,
    }),
    checkboxContainer: mergeStyles({
        position: "absolute",
        top: designTokens.spacing.sm,
        right: designTokens.spacing.sm,
        zIndex: 1,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: designTokens.borderRadius,
        padding: "2px",
    }),
    loadingContainer: mergeStyles({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
        padding: "32px",
    }),
    header: mergeStyles({
        display: "flex",
        alignItems: "center",
        gap: designTokens.spacing.sm,
        marginBottom: designTokens.spacing.md,
        paddingBottom: designTokens.spacing.sm,
        borderBottom: `1px solid ${designTokens.colors.borderLight}`,
    }),
    headerContent: mergeStyles({
        flex: 1,
    }),
    outageBadge: mergeStyles({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: "20px",
        minWidth: "64px",
        padding: "0 8px",
        borderRadius: "10px",
        backgroundColor: "#d13438",
        color: "#ffffff",
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.4px",
        textTransform: "uppercase",
    }),
    fieldRow: mergeStyles({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: designTokens.spacing.sm,
        gap: designTokens.spacing.sm,
    }),
    incidentTitle: mergeStyles({
        fontWeight: 600,
        lineHeight: "1.3",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        minHeight: "2.6em",
        maxHeight: "2.6em",
    }),
    fieldLabel: mergeStyles({
        fontWeight: 600,
        fontSize: "11px",
        color: "#666666",
        textTransform: "uppercase",
        minWidth: "80px",
        flexShrink: 0,
    }),
    fieldValue: mergeStyles({
        fontSize: "13px",
        color: designTokens.colors.text,
        wordBreak: "break-word",
        textAlign: "right",
        flex: 1,
    }),
    arrayValue: mergeStyles({
        display: "flex",
        flexWrap: "wrap",
        gap: "4px",
        justifyContent: "flex-end",
        flex: 1,
    }),
    arrayValueItem: mergeStyles({
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 8px",
        borderRadius: "12px",
        fontSize: "11px",
        fontWeight: 500,
        backgroundColor: "#f3f2f1",
        color: "#323130",
        whiteSpace: "nowrap",
    }),
    subscriptionItem: mergeStyles({
        marginBottom: "2px",
        fontFamily: "monospace",
        fontSize: "11px",
    }),
    statusBadge: mergeStyles({
        display: "inline-flex",
        alignItems: "center",
        gap: designTokens.spacing.xs,
        padding: `${designTokens.spacing.xs} ${designTokens.spacing.sm}`,
        borderRadius: designTokens.borderRadius,
        fontSize: "11px",
        fontWeight: 600,
        color: designTokens.colors.white,
    }),
    severityBadge: mergeStyles({
        display: "inline-block",
        padding: `${designTokens.spacing.xs} ${designTokens.spacing.sm}`,
        borderRadius: designTokens.borderRadius,
        fontSize: "11px",
        fontWeight: 600,
        color: designTokens.colors.white,
    }),
    icmLink: mergeStyles({
        fontSize: designTokens.fontSize.sm,
        fontWeight: 600,
    }),
    externalIcon: mergeStyles({
        marginLeft: designTokens.spacing.xs,
        fontSize: designTokens.fontSize.xs,
    }),
    // Status Colors
    statusActive: mergeStyles({
        backgroundColor: "#d13438",
    }),
    statusInvestigating: mergeStyles({
        backgroundColor: "#ff8c00",
    }),
    statusMitigated: mergeStyles({
        backgroundColor: designTokens.colors.primary,
    }),
    statusMonitoring: mergeStyles({
        backgroundColor: "#6bb6ff",
    }),
    statusResolved: mergeStyles({
        backgroundColor: "#107c10",
    }),
    // Severity Colors
    severityError: mergeStyles({
        backgroundColor: "#d13438", // Red for Error
    }),
    severityWarning: mergeStyles({
        backgroundColor: "#ffaa44", // Yellow/amber for Warning
    }),
    severityInformational: mergeStyles({
        backgroundColor: "#0078d4", // Blue for Informational
    }),
};
